import { useContext } from 'react';
import { Box, Icon, IconButton, Stack, Typography } from '@ace-clublabs/shared-component-library';
import { MembershipAppStateContext } from '../../components/MembershipAppState/MembershipAppState';
import { ProductType } from '../../application/models/NewJoinSessionData';
import { getProductPrice, eligibleForRV, eligibleForRVUpgrade } from '../../utils/helpers';
import { AddOn } from '../CustomizeMembershipComponents/AddOn';
import { ClubContentName, getClubContent } from '../../utils/getClubContent';
import { CurrentPayPlan } from '@ace-clublabs/common-membership-api-types';
import { AddedInfoCard } from './AddedInfoCard';

export interface RVAddOnPros {
  setTooltipInfo: Function;
  setTooltipContent: Function;
  setDeleteInfo: Function;
  selectedRV: boolean;
  onUpgradeClick: () => void;
}

export const RVAddOn: (props: RVAddOnPros) => JSX.Element = ({
  setTooltipInfo,
  setTooltipContent,
  setDeleteInfo,
  selectedRV,
  onUpgradeClick,
}) => {
  const { membershipInfo, updateProducts, sessionData } = useContext(MembershipAppStateContext);

  if (!eligibleForRV(membershipInfo)) {
    return <></>;
  }

  const hasToUpgrade = eligibleForRVUpgrade(membershipInfo, sessionData);
  const { billPlan } = sessionData.formData;
  const priceSuffix = billPlan === CurrentPayPlan.RECURRINGMONTHLY ? 'month' : 'year';

  return (
    <>
      <Box className="benefit-add-ons">
        <Stack direction="row" alignItems="center" gap="0.5rem">
          <Icon iconName="van-shuttle-duotone" sx={{ color: '#0C7A93', fontSize: '1.5rem' }} />
          <Typography className="benefit-add-ons-title add-rv-title" variant="b1Medium">
            Roadside for RV/motorcycle
          </Typography>
        </Stack>
        <IconButton
          aria-label="RVs Trailers & Motorcycle info"
          className="add-RV-info-icon"
          onClick={() => {
            setTooltipInfo({
              tooltipTitle: 'Roadside for RV/motorcycle',
            });
            setTooltipContent(
              hasToUpgrade
                ? 'Optional roadside for RV/motorcycle is not available at the Classic benefit level.'
                : getClubContent(ClubContentName.RVToolTip, sessionData.clubCode!)
            );
          }}
        >
          <Icon iconName="circle-info-regular" sx={{ color: '#707070' }} />
        </IconButton>
      </Box>
      {hasToUpgrade ? (
        <Box className="rv-upgrade">
          <AddOn
            onAdd={onUpgradeClick}
            onDelete={() => {}}
            text="Upgrade to Plus or Premier"
            price={getProductPrice(membershipInfo, ProductType.RV, sessionData)}
            isSelected={selectedRV}
            icon="membership-card-solid"
            type={ProductType.RV}
            showPrice={false}
          />
        </Box>
      ) : selectedRV ? (
        <AddedInfoCard
          className="rv-added-card"
          deleteButtonOnClick={() => {
            setDeleteInfo({
              title: 'Are you sure you want to remove roadside for RV/motorcycle?',
              confirmRemove: () => {
                updateProducts('remove', ProductType.RV);
              },
            });
          }}
          title="Added"
          originalPrice={getProductPrice(membershipInfo, ProductType.RV, sessionData)}
          priceSuffix={priceSuffix}
          content={
            <span>
              Changes <strong>will be effective seven (7) days</strong> after full payment is received.
            </span>
          }
        />
      ) : (
        <AddOn
          onAdd={() => updateProducts('add', ProductType.RV)}
          onDelete={() => {}}
          text="Add RV/motorcycle"
          price={getProductPrice(membershipInfo, ProductType.RV, sessionData)}
          isSelected={false}
          icon="van-shuttle-regular"
          type={ProductType.RV}
          priceSuffix={priceSuffix}
        />
      )}
    </>
  );
};
